import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useOrderReportQuery } from '../../../../Store/Apis/reportApi';
import Error from '../../../../Components/Error/Error';
import Loader from '../../../../Components/Loader/Loader';
import { useOutletsQuery } from '../../../../Store/Apis/outletApi';
import { useStatusQuery } from '../../../../Store/Apis/bookingApi';
import formatDate from '../../../../Hooks/formatDate';
import { useSelector } from 'react-redux';

const PrintOrdersReport = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
    const keyID = queryParams.get('outlet');
    const keynum = queryParams.get('status');

    const { data: Report, isSuccess, isLoading, isFetching, isError } = useOrderReportQuery({
        startDate,
        endDate,
        keyID,
        keynum
    }, { skip: !startDate })


    const outletList = useOutletsQuery()
    const statusList = useStatusQuery() 
    const outlet = keyID && outletList?.data?.data.find((elem) => (elem.outletId === Number(keyID)))
    const outletName = outlet?.outletName || ''
    const status = keynum && statusList?.data?.data.find((elem) => (elem.id === Number(keynum)))
    const statusName = status?.description || ''



    useEffect(() => {
           const sidebar = document.querySelector('aside.sidenav');
           const mainContent = document.querySelector('.sidenav.fixed-start + .main-content');
           const navbar = document.querySelector('.navbar-main');
         
           if (sidebar) sidebar.style.display = 'none';
           if (mainContent) mainContent.style.marginLeft = '0';
           if (navbar) navbar.style.display = 'none';
         }, []);

    useEffect(() => {
        if (isSuccess && outletList.isSuccess) {
            // Open print dialog on success
            window.print();

            // Close the page when the print dialog is closed
            const handleAfterPrint = () => {
                window.close();
            };

            window.addEventListener('afterprint', handleAfterPrint);

            return () => {
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [isSuccess, outletList.isSuccess, window]);

    if (!isSuccess) {
        return null;
    }

    return (
        <div className='card' id="invoice">
            <div className="card-body">
                <div className="page-wrapper" style={{ padding: 0 }}>
                    {isError && <Error />}
                    {(isLoading || isFetching) && <Loader height="300px" />}
                    {(!isLoading && !isFetching) && (
                        <>
                            <table className='table table-borderless align-items-center mb-3 table-sm border-0'>
                                <tbody>
                                    <tr>
                                        <td className='px-0 border-0'>
                                            <p className='text-sm mb-0 text-dark'>Start Date</p>
                                            {formatDate(startDate)}
                                        </td>
                                        <td className='px-0 border-0'>
                                            <p className='text-sm mb-0 text-dark'>End Date</p>
                                            {formatDate(endDate)}
                                        </td>
                                        {
                                            keyID && (
                                                <td className='px-0 border-0'>
                                                    <p className='text-sm mb-0 text-dark'>Outlet</p>
                                                    {outletName}
                                                </td>
                                            )
                                        }
                                        {
                                            keynum && (
                                                <td className='px-0 border-0'>
                                                    <p className='text-sm mb-0 text-dark'>Status</p>
                                                    {statusName}
                                                </td>
                                            )
                                        }
                                    </tr>
                                </tbody>
                            </table>

                            <div className="table-responsive mb-4">
                                <table className="table table-bordered align-items-center mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th style={{ width: '15%' }} className="text-uppercase text-secondary text-xs opacity-7 px-3">
                                                Date
                                            </th>
                                            <th style={{ width: '10%' }} className="text-uppercase text-secondary text-xs opacity-7 px-3">
                                                Order ID
                                            </th>
                                            <th style={{ width: '15%' }} className="text-uppercase text-secondary text-xs opacity-7 px-3">
                                                Customer
                                            </th>
                                            <th style={{ width: '15%' }} className="text-uppercase text-secondary text-xs opacity-7 px-3">
                                                Outlet
                                            </th>
                                            {/* <th style={{ width: '10%' }} className="text-uppercase text-secondary text-xs opacity-7 px-3">
                                                Quantity
                                            </th> */}
                                            <th style={{ width: '10%' }} className="text-uppercase text-secondary text-xs opacity-7 px-3">
                                                Order Amount
                                            </th>
                                            <th style={{ width: '15%' }} className="text-uppercase text-secondary text-xs opacity-7 px-3">
                                                Status
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Report.data.orders.length > 0 ? Report.data.orders.map((order) => (
                                            <tr key={order.orderNumber}>
                                                <td className='text-sm px-3'>{formatDate(order.orderDate)}</td>
                                                <td className='text-sm px-3'>{order.orderNumber}</td>
                                                <td className='text-sm px-3'>{order.customerName || 'N/A'}</td>
                                                <td className='text-sm px-3'>{order.outletName}</td>
                                                {/* <td className='text-sm px-3'>{order.quantity}</td> */}
                                                <td className='text-sm px-3'>R {order.orderAmount.toFixed(2)}</td>
                                                <td className='text-sm px-3'>{order.statusName}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={6} className="text-center py-5">No Data Found !!</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="row align-items-center mb-3">
                                <div className="col">
                                    <span className="text-sm mb-0 fw-500">Total Orders:</span>
                                    <span className="text-sm text-dark ms-2 fw-600 mb-0">{Report.data.totalOrders}</span>
                                </div>
                                <div className="col">
                                    <span className="text-sm mb-0 fw-500">Total Order Amount:</span>
                                    <span className="text-sm text-dark ms-2 fw-600 mb-0">R {Report.data.totalOrderAmount}</span>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PrintOrdersReport;
